import React from 'react';
import { AppRouteGroup } from 'app/store/components/NavigationUtils';

import { lazyRetry } from 'app/main/components';

const NewsPage = lazyRetry(() => import('./NewsPage'));

const routes: AppRouteGroup = {
	settings: {
		layout: {
			style: 'layout1',
			config: {
				toolbar: { display: false },
				navbar: { display: false }
			}
		}
	},
	routes: [
		{
			path: 'news',
			auth: null,
			element: <NewsPage />
		}
	]
};

export default routes;
